import { useCallback, useEffect, useRef, useState } from 'react'
import 'maplibre-gl/dist/maplibre-gl.css'
import styled from 'styled-components'
import { useGlobalStore } from '@/stores/globalStore'
import { useMapInitialization } from './lib/use-map-initialization'

const BUILDING_CENTER: [number, number] = [30.323477, 59.889941]

export function Map3D() {
  const mapContainer = useRef<HTMLDivElement | null>(null)
  const mapRef = useRef<maplibregl.Map | null>(null)
  const [mapReady, setMapReady] = useState(false)
  const setActiveLayer = useGlobalStore(state => state.setActiveLayer)
  const flyToBuilding = useGlobalStore(state => state.flyToBuilding)
  const clearFlyToBuilding = useGlobalStore(state => state.clearFlyToBuilding)

  useEffect(() => {
    if (!flyToBuilding || !mapReady || !mapRef.current) return
    const map = mapRef.current
    map.flyTo({
      center: BUILDING_CENTER,
      zoom: 18,
      pitch: 60,
      bearing: 30,
      duration: 1500,
    })
    clearFlyToBuilding()
  }, [flyToBuilding, mapReady, clearFlyToBuilding])

  const handleFloorClick = useCallback(
    (layerId: number) => {
      setActiveLayer(layerId)
    },
    [setActiveLayer],
  )

  useMapInitialization({
    mapContainer,
    mapRef,
    onFloorClick: handleFloorClick,
    onMapReady: useCallback(() => setMapReady(true), []),
  })

  return (
    <Wrapper>
      <MapCanvas ref={mapContainer} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const MapCanvas = styled.div`
  width: 100%;
  height: 100%;
`
